import { Icon, notification } from 'antd';
import axios from 'axios';
import moment from 'moment';
import React from 'react';

const api2pdfKey = process.env.API_KEY;

const axiosInstance = axios.create({
  baseURL: process.env.API_PDF_ROOT,
  headers: {
    Authorization: api2pdfKey,
  },
});

axiosInstance.interceptors.response.use(response => response.data, error => console.error(error));

/**
 * data format:
 *
 * html or url: toConvert (required)
 * inlinePdf: true, (optional - open the PDF in a browser window, default to false.)
 * fileName: 'test.pdf', (optional - random name if not specified.)
 * options: https://www.api2pdf.com/documentation/advanced-options-wkhtmltopdf/
 *
 * @param {string} url: {wkhtmltopdf} or {chrome} / {url} or {html}
 * @param {object} data
 */
export const convertToPdf = async (url, data, successCb) => {
  const notificationKey = Date.now();
  notification.open({
    key: notificationKey,
    message: 'Generating your PDF...',
    description: (
      <p>
        This could take a while. <Icon type="loading" spin style={{ paddingLeft: '16px' }} />
      </p>
    ),
    icon: <Icon type="file-pdf" theme="filled" style={{ color: '#003DA6' }} />,
    duration: 0,
  });
  const name =
    data.fileName &&
    data.fileName
      .replace(/[;]/g, '_')
      .replace(/,/g, '')
      .replace(/ /g, '-');

  const options = {
    displayHeaderFooter: true,
    footerTemplate: `
      <div style="
        width:100%;
        display:flex;
        justify-content:space-between;
        font-size:6px;
        margin: 0 40px;
      ">
        <div>${moment().format('MM/DD/YYYY')}</div>
        <div>
          Page <span class="pageNumber"></span> of <span class="totalPages"></span>
        </div>
      </div>
    `,
  };
  const res = await axiosInstance.request({
    method: 'post',
    url,
    data: { ...data, options, fileName: name },
  });
  const { success, pdf, responseId } = res;
  notification.close(notificationKey);
  if (successCb) {
    successCb(false);
  }
  if (success) {
    const fileName = name || `${responseId}.pdf`;
    const link = document.createElement('a');
    link.href = pdf;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  return res;
};

/**
 * data format:
 * { html, fileName, ... }
 * { options: https://www.api2pdf.com/documentation/advanced-options-headless-chrome/ }
 *
 * @param {object} data
 */
export const convertHtmlToPdf = (data, successCb) => {
  const url = '/chrome/html';
  return convertToPdf(url, data, successCb);
};
